import { render, staticRenderFns } from "./SearchSubscribe.vue?vue&type=template&id=df4579c2&scoped=true&"
import script from "./SearchSubscribe.vue?vue&type=script&lang=js&"
export * from "./SearchSubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4579c2",
  null
  
)

export default component.exports